import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ObjectLiteral } from '../models/ObjectLiteral';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor(private http: HttpClient) {}
  get(path: string, params?: ObjectLiteral) {
    return this.http.get<any>(environment.domain + path, {
      ...(params ? { params } : {}),
      //   withCredentials: true,
    });
  }
  post(
    path: string,
    data: ObjectLiteral,
    options?: {
      headers?: ObjectLiteral;
      [key: string]: any;
    }
  ) {
    return this.http.post<any>(environment.domain + path, data);
  }
  put(path: string, data: ObjectLiteral, options?: ObjectLiteral) {
    return this.http.put<any>(environment.domain + path, data, {
      ...(options ? options : {}),
      //   ...(params ? { params } : {}),
    });
  }
  delete(path: string, params: ObjectLiteral) {
    return this.http.delete<any>(environment.domain + path, {
      ...(params ? { params } : {}),
      //   withCredentials: true,
    });
  }
}
